import styled, { css } from "styled-components";

interface ButtonProps {
  $special?: boolean;
  $selected?: boolean;
  $danger?: boolean;
  $error?: boolean;
  width?: string;
}

export const Button = styled.button<ButtonProps>`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: ${({ width }) => width || "auto"};
  font-size: 16px;
  line-height: 16px;
  margin: 3px 0 0 20px;
  padding: 0;
  background: ${({ theme }) => theme.colors.button.transparent};
  color: ${({ theme }) => theme.colors.button.secendaryText};
  border: none;
  transition: filter 0.3s;
  user-select: none;
  white-space: nowrap;
  -webkit-tap-highlight-color: transparent;

  &[data-icon] {
    flex-direction: row;
  }

  &[data-icon]::before {
    content: attr(data-icon);
    margin-right: 4px;
  }

  ${({ $special }) =>
    $special &&
    css`
      margin: 0 0 0 10px;
      min-width: auto;
    `};

  ${({ $selected }) =>
    $selected &&
    css`
      text-decoration: underline;
      text-underline-offset: 5px;
    `};

  ${({ $danger }) =>
    $danger &&
    css`
      color: ${({ theme }) => theme.colors.status.error};
    `};

  @media (max-width: ${({ theme }) => theme.breakpoint.mobileMid}) {
    margin: 2px 10px 0;
    align-items: center;
  }

  &:hover {
    cursor: pointer;
    filter: brightness(110%);
  }

  &:active {
    filter: brightness(130%);
  }

  &:disabled {
    color: ${({ theme }) => theme.colors.button.disabled};
    filter: brightness(100%);
    cursor: auto;

    &[data-icon]::before {
      opacity: 0.3;
      margin-right: 4px;
      filter: grayscale(100%);
    }

    ${({ $error }) =>
      $error &&
      css`
        color: ${({ theme }) => theme.colors.status.error};
      `};
  }
`;
